import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { request } from "../../../utils/api";
import { formatYYYYMMDD } from "../../../utils";
import Loading from "../utilComponent/Loading";
import NotFoundTitle from "../utilComponent/NotFoundTitle";
import DateRangeFilter from "../utilComponent/DateRangeFilter";
import Pagination from "../utilComponent/Pagination";

const initialPagination = {
  current_page: 1,
  per_page: 15,
  total: 0,
  last_page: 1,
};

const ViewTracking = () => {
  const navigation = useNavigate();
  const [loading, setLoading] = useState(false);
  const [labelFolder, setLabelFolder] = useState([]);
  const [date, setDate] = useState();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [pagination, setPagination] = useState(initialPagination);

  const redirectUser = (p) => {
    navigation(`/tracking-list/${formatYYYYMMDD(p.date)}`);
  };

  const handleDateRangeChange = ({ fromDate, toDate }) => {
    setDate("");
    setFromDate(fromDate);
    setToDate(toDate);
    setPagination((p) => ({ ...p, current_page: 1 }));
  };

  const getLabelFolder = useCallback(async (page = 1) => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("per_page", pagination.per_page);

      if (date) {
        params.append("from_date", date);
        params.append("to_date", date);
      } else if (fromDate && toDate) {
        params.append("from_date", fromDate);
        params.append("to_date", toDate);
      } else if (fromDate) {
        params.append("from_date", fromDate);
      } else if (toDate) {
        params.append("to_date", toDate);
      }

      const response = await request({
        url: `labels-date-wise?${params.toString()}&approved=1`,
        method: "GET",
      });

      if (response.status && response.data) {
        setLabelFolder(response.data.items || []);
        setPagination((prev) => response.data.pagination || prev);
      } else {
        setLabelFolder([]);
        setPagination(initialPagination);
      }
    } catch (error) {
      setLabelFolder([]);
      setPagination(initialPagination);
    } finally {
      setLoading(false);
    }
  }, [date, fromDate, pagination.per_page, toDate]);

  useEffect(() => {
    getLabelFolder(pagination.current_page);
  }, [getLabelFolder, pagination.current_page]);

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, current_page: page }));
  };

  return (
    <div className="container-fluid p-0">
      <div className="page-toolbar px-xl-4 px-sm-2 px-0 py-3">
        <div className="container-fluid">
          <div className="row g-3 mb-3 align-items-center">
            <div className="col">
              <ol className="breadcrumb bg-transparent mb-0">
                <li className="breadcrumb-item">
                  <Link className="text-secondary" to="/">
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <span className="text-secondary">View</span>
                </li>
                <li className="breadcrumb-item active">View Tracking Folder</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="card mx-4">
        <div className="row px-4 my-3 g-3">
          <DateRangeFilter onChange={handleDateRangeChange} />
        </div>
        <hr
          style={{
            border: 0,
            borderTop: "2px dotted gray",
            margin: "10px 0",
          }}
        />
        <div className="row g-3 px-4 mt-2">
          {loading ? (
            <div className="col-12 text-center py-5">
              <Loading />
            </div>
          ) : labelFolder.length === 0 ? (
            <div className="col-12 text-center py-5">
              <NotFoundTitle title="No tracking data found" />
            </div>
          ) : (
            labelFolder.map((p) => (
              <div className="col-3" key={p.id}>
                <div
                  className="card mb-4"
                  style={{
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                >
                  <div className="card-body">
                    <p className="card-text mb-1">
                      <strong>Date:</strong> {p.date}
                    </p>
                    <p className="card-text mb-1">
                      <strong>Labels:</strong> {p.total_labels}
                    </p>
                    <div className="d-grid gap-2">
                      <button
                        className="btn btn-success"
                        onClick={() => redirectUser(p)}
                      >
                        Marked Label
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {pagination.last_page > 1 && (
          <div className="d-flex justify-content-center px-4 pb-4">
            <Pagination
              currentPage={pagination.current_page}
              lastPage={pagination.last_page}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewTracking;
